import { useTheme } from '../../providers/ThemeProvider'
import t from '../../service/translate.service'

const EditTheme = () => {
  const themeContext = useTheme()
  return (
    <div>
      <div>{t.TEXT_MAGNIFIER}</div>
      <div className="custom-toggle">
        {themeContext.magnifiers.map(magnifier => (
          <div
            key={magnifier.value}
            className={`item ${themeContext.activeMagnifier.label === magnifier.label ? "active" : ''}`}
            style={{cursor: "pointer"}}
            tabIndex="0"
            role="button"
            onClick={() => themeContext.setActiveMagnifier(magnifier)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // Prevent scrolling on space
                themeContext.setActiveMagnifier(magnifier);
              }
            }}
          >
        <div className='container'>{magnifier.label}</div>
      </div>
    ))}
  </div>
</div>
  )
}

export default EditTheme